import { type Meta } from '../types/docs';

const META: Meta = {
  description: 'An author hid or re-showed a content block on a collection share link page',
  name: 'block_hidden',
  params: [
    {
      description: 'True when the block was hidden, false when it was shown again',
      name: 'hidden',
      required: true,
      type: 'boolean',
    },
  ],
};

export default META;
